"use strict";

exports.__esModule = true;
exports.utils = void 0;
var _ = _interopRequireWildcard(require("lodash"));
var _urijs = _interopRequireDefault(require("urijs"));
var _httpClient = require("@wix/http-client");
var _photographyClientLib = require("@wix/photography-client-lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var httpClient = new _httpClient.HttpClient();
var Utils = /*#__PURE__*/function (_RenderUtils) {
  _inheritsLoose(Utils, _RenderUtils);
  /* @ngInject */
  function Utils() {
    var _this;
    _this = _RenderUtils.call(this) || this;
    _defineProperty(_assertThisInitialized(_this), "data", {
      set: function set(key, value) {
        var dataKey = _this.dataPublicKey(key);
        return new Promise(function (resolve, reject) {
          return _photographyClientLib.Wix.Data.Public.set(dataKey, value, {
            scope: 'APP'
          }, function (data) {
            return resolve(data.dataKey);
          }, function (err) {
            return reject(err);
          });
        });
      },
      get: function get(key) {
        var dataKey = _this.dataPublicKey(key);
        return new Promise(function (resolve, reject) {
          return _photographyClientLib.Wix.Data.Public.get(dataKey, {
            scope: 'APP'
          }, function (data) {
            return resolve(data.dataKey);
          }, function (err) {
            return reject(err);
          });
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "gallerySettings", function () {
      var baseUrl = _photographyClientLib.window.location.protocol + '//progallery.wixapps.net/_api/pro-gallery-editor-webapp/v1/gallery/';
      var getGallerySettingsApi = function getGallerySettingsApi() {
        return "" + baseUrl + _photographyClientLib.window.galleryId + "?instance=" + _photographyClientLib.window.instance + "&isStore=" + _this.isStoreGallery();
      };
      return {
        get: function get(key) {
          return httpClient.get(getGallerySettingsApi(), {
            withCredentials: true,
            xsrfCookieName: null
          }).then(function (_ref) {
            var data = _ref.data;
            return data.settings ? key ? data.settings[key] : data.settings : null;
          });
        },
        set: function set(key, value) {
          var _this$gallerySettings;
          return _this.gallerySettings.setMultiple((_this$gallerySettings = {}, _this$gallerySettings[key] = value, _this$gallerySettings));
        },
        setMultiple: function setMultiple(keysValuesObject) {
          return _this.gallerySettings.get().then(function (data) {
            data = data || {};
            var settings = Object.assign(data, keysValuesObject);
            return httpClient.put(getGallerySettingsApi(), {
              settings: settings
            }, {
              withCredentials: true,
              xsrfCookieName: null
            }).then(function () {
              return _this.setExternalId();
            });
          });
        },
        getAppSettings: function () {
          var _getAppSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(key) {
            var _value, value;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!_photographyClientLib.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                    _context.next = 12;
                    break;
                  }
                  _context.prev = 1;
                  _context.next = 4;
                  return _this.appSettings.get(_photographyClientLib.Consts.dataSavedState.SAVED, key);
                case 4:
                  _value = _context.sent;
                  if (!(_value !== undefined)) {
                    _context.next = 7;
                    break;
                  }
                  return _context.abrupt("return", Promise.resolve(_value));
                case 7:
                  _context.next = 12;
                  break;
                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](1);
                  console.error('Failed to get ' + key + ' from app settings: ' + _context.t0);
                case 12:
                  _context.next = 14;
                  return _this.gallerySettings.get(key);
                case 14:
                  value = _context.sent;
                  try {
                    if (_photographyClientLib.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                      _this.appSettings.set(key, value);
                    }
                  } catch (error) {
                    console.error('Failed to set ' + key + ' to app settings: ' + error);
                  }
                  return _context.abrupt("return", Promise.resolve(value));
                case 17:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[1, 9]]);
          }));
          function getAppSettings(_x) {
            return _getAppSettings.apply(this, arguments);
          }
          return getAppSettings;
        }()
      };
    }());
    _this._cache = {};
    _this._hash2int = {};
    _this._refs = {};
    _this._params = {};
    _this.CONST_ADI_SUPPORT_WIDGET_CODE = '63ff21be-9556-4f52-9ac9-4d441bd3dae4';
    _this.CONST_EDITOR_WIDGET_CODE = 'cb6480f3-768b-4737-ab8f-10fe2e4fa2ab';
    _this.openManagePhotos = _this.openManagePhotos.bind(_assertThisInitialized(_this));
    try {
      document.domain = 'wixapps.net';
    } catch (e) {
      // console.warn('failed to set domain');
    }
    _this.isAccessibilityEnabled(); // populate the cache with the sdk response
    _this.appSettings = new _photographyClientLib.AppSettings();
    return _this;
  }

  // isStoreGallery() {
  //   return true
  // }
  var _proto = Utils.prototype;
  _proto.addItemHashParam = function addItemHashParam(baseUrl, photoId) {
    var curParamsIndex = baseUrl.indexOf('pro-gallery-item=');
    if (curParamsIndex > 0) {
      baseUrl = baseUrl.substr(0, baseUrl.indexOf('pro-gallery-item=') - 1);
    }
    var prefix = '';
    var hashPart = baseUrl.split('#')[1];
    if (hashPart || hashPart === '') {
      var hasQuestionMark = hashPart.split('?')[1];
      if (hasQuestionMark) {
        prefix = '&';
      } else {
        prefix = '?';
      }
    } else {
      prefix = '#?';
    }
    return baseUrl + prefix + 'pro-gallery-item=' + photoId;
  };
  _proto.removeItemHashParam = function removeItemHashParam(baseUrl) {
    var itemPart = baseUrl.indexOf('pro-gallery-item=');
    // remove anything after the hash
    var newUrl = baseUrl.substr(0, itemPart > 0 ? itemPart - 1 : baseUrl.length);
    newUrl += newUrl.indexOf('#') > 0 ? '' : '#';
    return newUrl;
  };
  _proto.hexToRgba = function hexToRgba(hex, opacity) {
    hex = hex.replace('#', '');
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
  };
  _proto.setStateAndLog = function setStateAndLog(that, caller, state, callback) {
    var _this2 = this;
    if (this.isVerbose()) {
      console.log("State Change Called (" + caller + ")", state);
      var oldState = _.clone(that.state);
      that.setState(state, function () {
        var newState = _.clone(that.state);
        var change = _this2.printableObjectsDiff(oldState, newState, 'state');
        if (_.keys(change).length > 0) {
          console.log("State Change Completed (" + caller + ")", change);
        }
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    } else {
      that.setState(state, function () {
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    }
  };
  _proto.printableObjectsDiff = function printableObjectsDiff(obj1, obj2, prefix) {
    if (prefix === void 0) {
      prefix = '';
    }
    var toString = function toString(v) {
      if (v === '') {
        v = "''";
      } else if (_.isUndefined(v)) {
        v = 'undefined';
      }
      return _.toString(v);
    };
    var getInnerDiff = function getInnerDiff(obj1, obj2, prefix) {
      var innerDiff = _.reduce(obj1, function (res, v, k) {
        if (!_.isEqual(v, obj2[k])) {
          if (_.isArray(obj2[k])) {
            if (v.length !== obj2[k].length) {
              res[k + '.length'] = '[' + v.length + '] => [' + obj2[k].length + ']';
            }
            res = _.merge(res, getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
          } else if (_.isObject(obj2[k])) {
            res = _.merge(res, getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
          } else {
            res[(prefix ? prefix + '.' : '') + k] = toString(v) + ' => ' + toString(obj2[k]);
          }
        }
        return res;
      }, {});
      return innerDiff;
    };
    return getInnerDiff(obj1, obj2, prefix);
  };
  _proto.getViewportScaleRatio = function getViewportScaleRatio() {
    // 320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
    if (this.isMobile() && !this.isMobileViewer() && this.isSite()) {
      return 320 / this.getScreenWidth();
    } else {
      return 1;
    }
  };
  _proto.debounceWithContext = function debounceWithContext(context, debouncedFunction, delay) {
    if (delay === void 0) {
      delay = 300;
    }
    return _.bind(_.debounce(debouncedFunction, delay), context);
  };
  _proto.openModalImp = function openModalImp(url, width, height, onClose) {
    if (width === void 0) {
      width = '100%';
    }
    if (height === void 0) {
      height = '100%';
    }
    if (onClose === void 0) {
      onClose = _.noop;
    }
    return new Promise(function (resolve, reject) {
      _photographyClientLib.Wix.Settings.openModal(url, width, height, undefined, function () {
        onClose();
        resolve();
      }, true, {
        overlay: 'rgba(0,0,0,0)',
        background: 'rgba(0,0,0,0)',
        margin: false
      });
    });
  };
  _proto.openManagePhotos = function openManagePhotos() {
    return this.openModalImp(this.getManageMediaUrl());
  };
  _proto.openExpandSettings = function openExpandSettings(params) {
    this.openModalImp(this.getExpandSettingsUrl(params));
  };
  _proto.openSettingsWatermarkDisableDialog = function openSettingsWatermarkDisableDialog(callback) {
    _photographyClientLib.Wix.Settings.openModal(this.getSettingsWatermarkDisableUrl(), 612, 281, undefined, callback, true);
  };
  _proto.openSettingsAddonsUrl = function openSettingsAddonsUrl(params, callback) {
    _photographyClientLib.Wix.Settings.openModal(this.getSettingsAddonsUrl(params), 736, 281, undefined, callback, true);
  };
  _proto.findFontsHrefs = function findFontsHrefs() {
    try {
      var isFontHref = function isFontHref(x) {
        return x.toLowerCase().includes('font');
      };
      var styleSheets = top.document.styleSheets;
      return Object.keys(styleSheets).map(function (s) {
        return styleSheets[s].href;
      }).filter(function (href) {
        return href !== null;
      }).filter(isFontHref);
    } catch (e) {
      // console.warn('could not find fonts hrefs', e);
      return [];
    }
  };
  _proto.getSupportLink = function getSupportLink(progalleryLinks, storeLinks) {
    var editorArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[0] : progalleryLinks[0] : progalleryLinks[0];
    var onBoardingArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[1] : progalleryLinks[1] : progalleryLinks[1];
    var articleUrl = '';
    var isOnboarding = this.isOnBoarding() || !editorArticleId;
    if (editorArticleId || onBoardingArticleId) {
      var widgetCode = '';
      var articleId = '';
      var subDomain = 'support';
      var isOnBoardingReallyExists = isOnboarding && onBoardingArticleId;
      var hasOnBoardingOnly = !editorArticleId && onBoardingArticleId;
      if (isOnBoardingReallyExists || hasOnBoardingOnly) {
        widgetCode = this.CONST_ADI_SUPPORT_WIDGET_CODE;
        articleId = onBoardingArticleId;
      } else if (editorArticleId) {
        widgetCode = this.CONST_EDITOR_WIDGET_CODE;
        articleId = editorArticleId;
      }
      if (_.isUndefined(_photographyClientLib.window.locale)) {
        _photographyClientLib.window.locale = 'en';
      }
      var locale = _photographyClientLib.window.locale;
      var path = "/" + locale + "/widget/" + widgetCode + "/article/" + articleId;
      var url = new _urijs["default"]('https://wix.com/').path(path).subdomain(subDomain);
      articleUrl = url.toString();
    }
    return articleUrl;
  };
  _proto.mergeDeep = function mergeDeep() {
    var _mergeDeep = function _mergeDeep(dstObj, srcObj) {
      var mergeId;

      // const clonedDstVal = _.cloneDeep(dstObj);
      var res = _.mergeWith(dstObj, srcObj, function (dstVal, srcVal) {
        if (_.isObject(dstVal) && !_.isFunction(dstVal)) {
          // isObject return true for functions too
          return _mergeDeep(dstVal, srcVal);
        } else {
          return srcVal;
        }
      });
      return res;
    };
    var merged = {};
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i]) {
        merged = _mergeDeep(merged, arguments[i]);
      }
    }
    return merged;
  };
  _proto.getImageUrl = function getImageUrl(fileName) {
    return (_photographyClientLib.window.staticsUrl || '') + fileName;
  };
  _proto.markWidgetInSite = function markWidgetInSite(widgetId) {
    var instanceId = _photographyClientLib.window.instanceId;
    this.getLocalStorage()[instanceId + '|has-widget|' + widgetId] = true;
  };
  _proto.isWidgetInSite = function isWidgetInSite(widgetId) {
    var instanceId = _photographyClientLib.window.instanceId;
    return !_.isUndefined(this.getLocalStorage()[instanceId + '|has-widget|' + widgetId]);
  };
  _proto.getMobileEnabledClick = function getMobileEnabledClick(action) {
    // todo: bring back this line before pushing to master
    return this.isMobile() ? {
      onTouchEnd: action
    } : {
      onClick: action
    };
    // return {onClick: action};
  };
  _proto.uploadImageFromUrl = function uploadImageFromUrl(imageUrl) {
    var imageUrlTemplateBase64 = _photographyClientLib.window.btoa(imageUrl);
    var updloadMediaUrlTemplate = location.protocol + "//files.wix.com/files/upload/external?media_type=picture&ns=campaign&name=_.jpg&url=" + encodeURIComponent(imageUrl);
    return this.getUploadMediaRequest(updloadMediaUrlTemplate, 10000);
  };
  _proto.getUploadMediaRequest = function getUploadMediaRequest(uploadMediaUrl, timeout) {
    return httpClient.request({
      url: uploadMediaUrl,
      method: 'GET',
      timeout: timeout,
      withCredentials: true,
      xsrfCookieName: null
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  };
  _proto.isInExpandSettings = function isInExpandSettings() {
    return this.parseGetParam('expandsettingsmode') === '1';
  };
  _proto.isStoreDemoImages = function isStoreDemoImages() {
    var _this3 = this;
    // NOTE: the next few lines are commented because otherwise cannot check debugApp=ph_local/ph_debug
    // if (this.isDev()) { //development mode cannot upload images so is is default false
    //   return Promise.resolve(false);
    // }
    if (this.isInExpandSettings()) {
      // expand settings uses default images
      return Promise.resolve(true);
    }
    return this.gallerySettings.getAppSettings('isStoreDemoImages').then(function (isDemo) {
      if (isDemo === undefined) {
        throw 'not in gallerySettings, fallback to dataPublic';
      }
      return isDemo;
    })["catch"](function (e) {
      return _this3.data.get('isStoreDemoImages').then(function () {
        return false;
      })["catch"](function (e) {
        if (_this3.isDev()) {
          console.log('error fetching store default images', e);
        }
        return !!(e && e.error && e.error.message && e.error.message.indexOf('not found in APP scope') > 0);
      });
    });
  };
  _proto.getProviderFromGalleryInfo = function getProviderFromGalleryInfo(galleryInfo) {
    if (galleryInfo && galleryInfo.connectedProviders) {
      return Object.keys(galleryInfo.connectedProviders)[0];
    }
    return null;
  };
  _proto.dataPublicKey = function dataPublicKey(key) {
    try {
      var compId = _photographyClientLib.Wix.Utils.getOrigCompId() || _photographyClientLib.Wix.Utils.getCompId();
      return key + '-' + compId;
    } catch (e) {
      // console.error('Cannot get compId', e);
      return key + '-no-comp-id';
    }
  };
  _proto.openMediaDialogAndApplyWatermark = function openMediaDialogAndApplyWatermark(callback) {
    _photographyClientLib.Wix.Dashboard.openMediaDialog(_photographyClientLib.Wix.Settings.MediaType.IMAGE_PRO, true, function (result) {
      var galleryId = _photographyClientLib.window.galleryId;
      var instance = _photographyClientLib.window.instance;
      _photographyClientLib.watermarkApi.applyWatermarkOnMediaDialogResult(result, galleryId, instance).then(function (watermarkData) {
        callback(result);
      });
    });
  };
  _proto.colorStringToObject = function colorStringToObject(colorString) {
    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    try {
      var returnValue = null;
      if (typeof colorString === 'string') {
        if (colorString.trim().indexOf('rgb') === 0) {
          // rgb(1,2,3) | rgba(4,5,6,0.7)
          var values = colorString.match(/\d+/g);
          if (values && Array.isArray(values) && values.length >= 3) {
            returnValue = {
              r: values[0],
              g: values[1],
              b: values[2]
            };
          }
        } else {
          // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
          var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          colorString = colorString.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
          });
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorString);
          returnValue = result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }
      }
      return returnValue;
    } catch (error) {
      console.error('Error converting color string to object', error);
    }
  };
  _proto.getExperimentValue = function getExperimentValue(experimentName) {
    return _.get(_photographyClientLib.window, ['petri', "specs.pro-gallery." + experimentName]);
  };
  _proto.getDateCreatedTicksFromStr = function getDateCreatedTicksFromStr(dateCreatedStr) {
    var dateCreatedTicks = null;
    var isDateCreatedValid = isNaN(Date.parse(dateCreatedStr)) === false;
    if (isDateCreatedValid) {
      return Date.parse(dateCreatedStr);
    }
    return -8640000000000000;
  };
  _proto.getQueryParamByName = function getQueryParamByName(name, url) {
    if (url === void 0) {
      url = _photographyClientLib.window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };
  _proto.getBaseUrl = function getBaseUrl() {
    if (_photographyClientLib.window.location.origin.includes('manage.editorx')) {
      return '//manage.editorx.com';
    }
    return '//manage.wix.com';
  };
  return Utils;
}(_photographyClientLib.RenderUtils);
var utils = new Utils();
exports.utils = utils;